import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { WhatIncludesSection } from './components/WhatIncludesSection';
import { IdealParaSection } from './components/IdealParaSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialSection } from './components/TestimonialSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel via inline script
    try {
      const f = window as any;
      if (f.fbq) return;
      const n: any = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1379305313659580');
      f.fbq('track', 'PageView');
    } catch (error) {
      console.error('Error initializing Meta Pixel:', error);
    }
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-orange-50 via-amber-50/50 to-orange-100/60 font-sans selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <WhatIncludesSection data-id="element-3" />
      <IdealParaSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <TestimonialSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <SocialProofPopup data-id="element-10" />
    </div>;
}